import React from 'react'
import { utility } from '../../../utility/utilityProvider'

const MultiLangInput = (props) => {

    let isoCode = props.selectedLanguage ? props.selectedLanguage.ISOCode : "en_US1";

    return (
        <div className="form-group">
            <label htmlFor="">{props.label} *</label>
            <input
                type="text"
                className="form-control form-control-sm"
                name={`${props.name}`}
                value={Array.isArray(props.dataItem[`${props.name}`]) ?
                    props.dataItem[`${props.name}`].find((x) => x.langISO == isoCode) ?
                        props.dataItem[`${props.name}`].find((x) => x.langISO == isoCode).value : "" :
                    props.dataItem[`${props.name}`]
                }
                onChange={(e) => props.setDataItem(utility.handleInputChangeWithLang(e, props.dataItem, props.selectedLanguage))}
            />
        </div>
    )
}

export default MultiLangInput